import React from 'react';
import Modal from '../../../../../components/Modal/Modal';
import Slider from '../../../../../components/utils/Slider';
import Img from '../../../../../components/Img';
import './ReturnExchangeReasonModal.scss';

const ReturnExchangeReasonModal = (props) => {
  const { isOpen, data, closeModal } = props;
  const { attachments, title, reason } = data;

  /**
   *  사진이 없을때는 적용하지 않고, 1장일때는 600 2,3장일때는 650 으로 한다(아래에 dots 에 사진이 들어가기 때문)
   */
  const modalHeight = attachments.length > 0 ? (attachments.length > 1 ? 650 : 600) : '';

  return (
    <Modal
      title={title}
      isOpen={isOpen}
      width={600}
      height={modalHeight}
      onOk={() => closeModal()}
      onClose={() => closeModal()}
    >
      <div className="return-exchange-reason-modal-wrap">
        <div className="reason">{reason}</div>

        {attachments.length > 0 ? (
          <Slider
            list={attachments}
            customPaging={(slide) => (
              <div className="dot-class">
                <img src={attachments[slide]} />
              </div>
            )}
            item={(url) => <Img height={500} src={url} />}
          />
        ) : (
          ''
        )}
      </div>
    </Modal>
  );
};

export default ReturnExchangeReasonModal;
